function checkEmail(email) {
    if (!email) return
    return email.match(/.+@.+\.[a-z]{2,}/)
}

function footerSubmit() {
    var $footerForm = $('.footer-signup form')
    $footerForm.submit(function (e) {
        e.preventDefault()
        var $this = $(this)
        var $input = $this.find('input[name="email"]')
        var email = $input.val()
        if (!checkEmail(email)) return alert('Please provide a valid email address.')

        $input.hide()
        $('.footer-signup').append('<p>Processing...</p>')

        var options = {
            vendor: 'klaviyo-subscribe',
            action: 'subscribe',
            email: email,
            list_id: 'QMJ7TG',
            signup_location: 'Footer'
        }
        window.wb_apihelper(options, function (err, res) {
            if (err) {
                $('.footer-signup p').remove()
                $input.show()
                return alert('Sorry there was an issue saving your email. Please try again or contact support.')
            }
            console.log('res', res)
            $('.footer-signup p').text("You're in!")
            $footerForm.remove()
        })
    })
}

document.addEventListener('DOMContentLoaded', () => {
    footerSubmit();
});
